import { ADBLOCK, ADBLOCK_SET_ERROR, ADBLOCK_HIDE_ERROR, ADBLOCK_START_LOADER, ADBLOCK_STOP_LOADER, } from "./../../interfaces/Home/iAdBlock";
const initialState = {
    data: [],
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const adBlock = (state = initialState, action) => {
    switch (action.type) {
        case ADBLOCK:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case ADBLOCK_SET_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case ADBLOCK_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case ADBLOCK_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case ADBLOCK_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default adBlock;
